import Vue from 'vue'
import {
  Pagination,
  Carousel,
  CarouselItem,
  Loading
  // MessageBox,
  // Message
} from 'element-ui'

// element 引入
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
// Vue.prototype.$msgbox = MessageBox
// Vue.prototype.$alert = MessageBox.alert
// Vue.prototype.$confirm = MessageBox.confirm
// Vue.prototype.$prompt = MessageBox.prompt
// Vue.prototype.$notify = Notification
// Vue.prototype.$message = Message
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 1024 }
